module.exports = __webpack_public_path__ + "files/84faed22ffa10ba4da4d88da185a28a7.svg";